// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-title {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    padding-top: 2rem;
    padding-bottom: 3rem;
    color: #B54708;
}

.contact-content {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 3rem;
}

.contact-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #FFFAEB;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-title {
    font-size: 1.8rem;
    font-weight: bold;
    text-align: left;
    color: #B54708;
}

.form-subtitle {
    font-size: 1rem;
    text-align: left;
    margin-top: 5px;
    color: #666;
}

.form-input,
.form-textarea {
    border-radius: 1.5rem;
    padding: 1rem 2rem;
    width: 100%;
    border: 1px solid #ddd;
    margin-top: 1rem;
    background: #fff;
}

.form-textarea {
    border-radius: 1.5rem;
}

.form-button {
    border-radius: 1.5rem;
    padding: 0.8rem 4rem;
    width: 100%;
    background: #F09300;
    text-transform: none;
    margin-top: 2rem;
    color: #fff;
    font-weight: bold;
    transition: background 0.3s ease;
}

.form-button:hover {
    background: #DC6803;
}

.dealers-title {
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    padding-top: 8rem;
    padding-bottom: 3rem;
}

.dealers-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.dealer-card {
    flex: 1 1;
    margin: 1rem;
}

.dealer-image {
    border-radius: 8px;
    width: 100%;
    height: auto;
}

.dealer-info {
    margin-top: 1rem;
}

.dealer-name {
    font-size: 1.2rem;
    font-weight: bold;
    color: #000;
}

.dealer-address,
.dealer-hours {
    font-size: 0.8rem;
    color: #444;
    line-height: 1.5rem;
}

.dealer-hours-title {
    font-size: 1.2rem;
    margin: 2rem 0;
    font-weight: bold;
    color: #000;
}

.contact-iframe {
    width: 70%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
    .contact-content {
        flex-direction: column;
        align-items: center;
    }

    .dealers-content {
        flex-direction: column;
        align-items: center;
    }

    .dealer-card {
        width: 100%;
        margin: 0;
        margin-top: 1.5rem;
    }

    .contact-iframe {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/contact/contact.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".contact-title {\n    font-size: 1.5rem;\n    font-weight: bold;\n    text-align: center;\n    padding-top: 2rem;\n    padding-bottom: 3rem;\n    color: #B54708;\n}\n\n.contact-content {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: center;\n    gap: 3rem;\n}\n\n.contact-form {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: #FFFAEB;\n    padding: 2rem;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.form-title {\n    font-size: 1.8rem;\n    font-weight: bold;\n    text-align: left;\n    color: #B54708;\n}\n\n.form-subtitle {\n    font-size: 1rem;\n    text-align: left;\n    margin-top: 5px;\n    color: #666;\n}\n\n.form-input,\n.form-textarea {\n    border-radius: 1.5rem;\n    padding: 1rem 2rem;\n    width: 100%;\n    border: 1px solid #ddd;\n    margin-top: 1rem;\n    background: #fff;\n}\n\n.form-textarea {\n    border-radius: 1.5rem;\n}\n\n.form-button {\n    border-radius: 1.5rem;\n    padding: 0.8rem 4rem;\n    width: 100%;\n    background: #F09300;\n    text-transform: none;\n    margin-top: 2rem;\n    color: #fff;\n    font-weight: bold;\n    transition: background 0.3s ease;\n}\n\n.form-button:hover {\n    background: #DC6803;\n}\n\n.dealers-title {\n    font-size: 2rem;\n    font-weight: bold;\n    text-align: center;\n    padding-top: 8rem;\n    padding-bottom: 3rem;\n}\n\n.dealers-content {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.dealer-card {\n    flex: 1;\n    margin: 1rem;\n}\n\n.dealer-image {\n    border-radius: 8px;\n    width: 100%;\n    height: auto;\n}\n\n.dealer-info {\n    margin-top: 1rem;\n}\n\n.dealer-name {\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: #000;\n}\n\n.dealer-address,\n.dealer-hours {\n    font-size: 0.8rem;\n    color: #444;\n    line-height: 1.5rem;\n}\n\n.dealer-hours-title {\n    font-size: 1.2rem;\n    margin: 2rem 0;\n    font-weight: bold;\n    color: #000;\n}\n\n.contact-iframe {\n    width: 70%;\n    height: auto;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n    .contact-content {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .dealers-content {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .dealer-card {\n        width: 100%;\n        margin: 0;\n        margin-top: 1.5rem;\n    }\n\n    .contact-iframe {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
